import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const OccupancyLosDataPointDtoSchema = z.object({
  facilityName: z.string(),
  occupancy: z.number().nullable(),
  los: z.number().nullable(),
});

const GetOccupancyLosScatterResponseDtoSchema = z.object({
  data: z.array(OccupancyLosDataPointDtoSchema),
});

const _GetOccupancyLosScatterRequestDtoSchema = z.object({
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  includeAllOrgFacilities: z.boolean().optional(),
});

export type GetOccupancyLosScatterRequestDto = z.infer<
  typeof _GetOccupancyLosScatterRequestDtoSchema
>;
export type GetOccupancyLosScatterResponseDto = z.infer<
  typeof GetOccupancyLosScatterResponseDtoSchema
>;

export const getOccupancyLosScatter = (
  params: GetOccupancyLosScatterRequestDto,
  config?: AxiosRequestConfig<GetOccupancyLosScatterRequestDto>
) => {
  return api
    .get('/facilities/occupancy-los-scatter', { params, ...config })
    .then(responseContract(GetOccupancyLosScatterResponseDtoSchema));
};
